import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  chartStatus: {
    loading: false,
    noData: false
  },
  selectedFilters: {
    category: 0,
    brand: 0,
    seller: 0,
    date: 1
  },
  categories: [],
  sellers: [],
  brands: [],
  dates: [1, 2, 3, 4, 5],
  chartOptions: {
    chart: {
      id: 'price-alternation-chart',
      stacked: true,
      toolbar: {
        show: false
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    dataLabels: {
      enabled: true
    },
    legend: {
      show: false
    },
    stroke: {
      show: true,
      curve: 'smooth',
      lineCap: 'butt',
      colors: undefined,
      width: 0,
      dashArray: 0
    },
    grid: {
      strokeDashArray: 3
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.1,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 80]
      }
    },
    colors: ['#56e2cf', '#56aee3', '#307fff', '#5668e2', '#cf55e2', '#e356ae', '#e25567', '#e28955', '#e2cf56', '#aee255'],
    xaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      labels: {
        show: true,
        format: 'HH'
      },
      categories: []
    },
    yaxis: {
      showAlways: true,
      forceNiceScale: true,
      axisBorder: {
        show: false
      }
    },
    series: []
  }
}

const getters = {

}

let elemRef = null
let elemRefPopup = null

const actions = {
  getChart ({ commit }, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      if (filter.elemRef && filter.elemRefPopup) {
        elemRef = filter.elemRef
        elemRefPopup = filter.elemRefPopup
      }
      axios.post(AppUrl, {
        task: 'loadModule',
        payload: {
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          seller_id: filter.sellerId,
          date_option: filter.dateOption,
          module_id: 2
        }
      })
        .then(response => {
          console.log('Price Alterations Chart Load', response.data.payload)
          if (response.data.payload.categories && response.data.payload.series) {
            commit('SET_ChartOptions', {categories: response.data.payload.categories, series: response.data.payload.series})
            commit('SET_noData', false)
            resolve()
          } else {
            commit('SET_noData', true)
            resolve()
          }
          commit('SET_loading', false)
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getCategories ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          category_name: filter.categoryName,
          seller_id: filter.sellerId,
          brand_id: filter.brandId,
          date_option: filter.dateOption,
          module_id: 2
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_categories', response.data.payload.category)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSellers ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          seller_name: filter.sellerName,
          brand_id: filter.brandId,
          category_id: filter.categoryId,
          date_option: filter.dateOption,
          module_id: 2
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_sellers', response.data.payload.seller)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getBrands ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          brand_name: filter.brandName,
          category_id: filter.categoryId,
          date_option: filter.dateOption,
          seller_id: filter.sellerId,
          module_id: 2
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_brands', response.data.payload.brand)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, boolean) {
    state.chartStatus.loading = boolean
  },
  SET_noData (state, bool) {
    state.chartStatus.noData = bool
    if (bool) {
      state.chartOptions.xaxis.categories = []
      state.chartOptions.series = []
    }
  },
  SET_categories (state, data) {
    state.categories = data
  },
  SET_sellers (state, data) {
    state.sellers = data
  },
  SET_brands (state, data) {
    state.brands = data
  },
  SET_ChartOptions (state, data) {
    console.log('elemRef**************', elemRef)
    if (elemRef && elemRefPopup) {
      elemRef.refresh()
      elemRefPopup.refresh()
    }
    state.chartOptions.xaxis.categories = data.categories
    state.chartOptions.series = data.series
  },
  SET_selectedFilters (state, data) {
    state.selectedFilters[data.key] = data.value
  },
  RESET_selectedFilters (state) {
    let obj = state.selectedFilters
    for (let key in obj) {
      obj[key] = 0
      if (key === 'date') {
        obj[key] = 1
      }
    }
    state.selectedFilters = obj
  },
  RESET_currentFilter (state, data) {
    let obj = state.selectedFilters
    obj[data.key] = 0
    if (data.key === 'date') {
      obj[data.key] = 1
    }
    state.selectedFilters = obj
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pricealternations.js